import { useState } from 'react';
import { Watch } from 'lucide-react';
import { GlassCard } from './SharedUI';
import { CollapseHeader, CollapseSection } from './NeuralSynthesisMonitor';
import { WearableHealthCard, useWearableMockData } from './WearableHealthCard';

/**
 * 智能穿戴面板（独立卡片）
 * 从 NeuralSynthesisMonitor 抽离，受 "显示智能穿戴" 开关（xf_wearable_enabled）独立控制，
 * 与 "显示神经合成监控" / "显示米家设备" 互不依赖。
 */
export function WearablePanel({ t }: { t?: any }) {
  const wearableData = useWearableMockData();
  const [wearableCollapsed, setWearableCollapsed] = useState(false);

  return (
    <GlassCard className="p-5 rounded-[2.5rem] space-y-1.5 border-white/5 bg-black/30 backdrop-blur-3xl">
      <div className="space-y-1">
        <CollapseHeader
          icon={<Watch size={10} />}
          label={`智能穿戴 · ${wearableData.deviceName}`}
          collapsed={wearableCollapsed}
          onToggle={() => setWearableCollapsed(v => !v)}
        />
        <CollapseSection collapsed={wearableCollapsed}>
          <WearableHealthCard data={wearableData} />
        </CollapseSection>
      </div>
    </GlassCard>
  );
}
